/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VideoDto } from '../../models/video-dto';

export interface VideoControllerFindById$Params {
  id: string;
}

export function videoControllerFindById(http: HttpClient, rootUrl: string, params: VideoControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoDto>> {
  const rb = new RequestBuilder(rootUrl, videoControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VideoDto>;
    })
  );
}

videoControllerFindById.PATH = '/api/videos/{id}';
